const data = [
  {
    componentCategory: "Plastic Components",
    details: "",
    componentsData: [
      {
        imageUrl: "assets/img/plastic-components/Plastic-component-1.jpeg",
        componentName: "Single Screw Connector",
      },
      {
        imageUrl: "assets/img/plastic-components/Plastic-component-2.jpeg",
        componentName: "Dual Big Connector",
      },
      {
        imageUrl: "assets/img/plastic-components/Plastic-component-3.jpeg",
        componentName: "Double Screw Connector",
      }
    ],
  },
];


export default data;